import { init as initUser } from "@/features/user";
import { init as initMenu } from "@/features/menu";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const initFeatures = () => {
  // initCode();
  initUser();
  initMenu();
  // initPort();

  // initSku();

  // initInbdStatus();
  // initStatusPerAmr();
  // initStatusRsInbd();
  // initOutbdDasStatus();
  // initStatusPerDay();
  // initStatusPerHour();

  // initCst();
  //initTote();
  //initToteTrayMapping();

  // initPutIn();
  // initPutInForm();

  // initUserSuper();
  //initUserTenant();

  // initTenantMenu();
  // initTenant();
  //initWmsUrl();
  // initLangMenu();
  // initLangCode();

  // initRoleMenu();

  //HD 현대
  // initTamrTote();
  // initTamrPallet();
  // initStatusRsObnd();

  // initItem();
  // initLoc();
  // initCenter();
};
